export const SET_SERVICES_CONTENT = 'SET_SERVICES_CONTENT'
